import * as React from "react";
const SvgPaypal = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.93 12.99c.1 0 2.42.1 3.8-.24h.01c1.59-.39 3.8-1.51 4.37-5.17 0 0 1.27-4.58-5.03-4.58H7.67c-.49 0-.91.36-.99.84L4.38 18.4c-.05.3.19.58.49.58H8.3l.84-5.32c.06-.38.39-.67.79-.67z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.99 8.29c-.81 3.73-3.36 5.7-7.42 5.7H10.1l-1.03 6.52c-.04.26.16.49.42.49h1.9c.34 0 .64-.25.69-.59.08-.4.52-3.32.61-3.82.05-.34.35-.59.69-.59h.44c2.82 0 5.03-1.15 5.68-4.46.26-1.34.12-2.44-.51-3.25z",
  fill: "currentColor"
}));
export default SvgPaypal;